<template>
    <div
        :class="[
            'fixed right-0 bottom-0 h-full flex flex-col overflow-y-auto',
            'bg-white',
            'lg:max-w-[492px] w-[492px] max-w-full min-w-full lg:min-w-[492px]',
        ]"
        :style="{ zIndex }"
    >
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'StepOptionsNestedPanelWrapper',

        props: {
            zIndex: {
                type: Number,
                default: 70,
            },
        },
    };
</script>
